import sidebarBgImage from 'assets/img/sidebar/sidebar-4.jpg';
import SourceLink from 'components/SourceLink';
import React from 'react';
import { connect } from 'react-redux';
import { checkPermissions } from 'hooks';
import {MdSettings,
  MdDashboard, MdAccountCircle, MdVpnKey, MdSearch, MdReport, MdErrorOutline, MdDns, MdKeyboardArrowDown, MdCampaign, MdPaid, MdOutlineFavorite, MdOutlineLocationOn
} from 'react-icons/md';
import { NavLink } from 'react-router-dom';
import {
  Nav,
  Navbar,
  NavItem,
  NavLink as BSNavLink,
  Collapse
} from 'reactstrap';
import bn from 'utils/bemnames';




const bem = bn.create('sidebar');

class Sidebar extends React.Component {
  state = {
    isOpenPages: false,
  };

  handleClick = name => () => {
    this.setState(prevState => {
      const isOpen = prevState[`isOpen${name}`];
      return {
        [`isOpen${name}`]: !isOpen,
      };
    });
  };

  render() {
    const loginData = this.props.loginData;
    let navItems = [];
    (checkPermissions(loginData, 'dashboard_data') ||
      checkPermissions(loginData, 'google_analytics') ||
      checkPermissions(loginData, 'campaign_analytics') ||
      checkPermissions(loginData, 'google_analytics_graph') ||
      checkPermissions(loginData, 'top_searches')) && navItems.push({ to: '/', name: 'dashboard', Icon: MdDashboard });
    //checkPermissions(loginData, 'campaign_list') && navItems.push({ to: '/campaign-list', name: 'Campaign', Icon: MdDashboard });

    if (process.env.REACT_APP_VERSION && process.env.REACT_APP_VERSION !== '1.0.0') {
      let campaignMenus = [];
      checkPermissions(loginData, 'campaign_list') && campaignMenus.push({ to: '/campaign-list', name: 'Campaign List', Icon: MdCampaign });
      checkPermissions(loginData, 'campaign_charges_list') && campaignMenus.push({ to: '/campaign-charges', name: 'Charges', Icon: MdPaid });
      checkPermissions(loginData, 'campaign_interests') && campaignMenus.push({ to: '/interest', name: 'Interest', Icon: MdOutlineFavorite });
      checkPermissions(loginData, 'transaction_history') && campaignMenus.push({ to: '/transactions', name: 'Transactions', Icon: MdPaid });
      if (campaignMenus.length > 0) {
        navItems.push({
          name: 'CAMPAIGN', Icon: MdCampaign,
          subMenus: campaignMenus
        });
      }
    }



    checkPermissions(loginData, 'users_locations') && navItems.push({ to: '/geographical-users-count', name: 'Geographic Data', Icon: MdOutlineLocationOn });
    checkPermissions(loginData, 'users_list') && navItems.push({ to: '/users', name: 'users', Icon: MdAccountCircle });
    checkPermissions(loginData, 'reported_users') && navItems.push({ to: '/reported-users', name: 'Reported users', Icon: MdReport });
    checkPermissions(loginData, 'reported_posts') && navItems.push({ to: '/reported-posts', name: 'Reported Posts', Icon: MdReport });
    checkPermissions(loginData, 'admin_users_list') && navItems.push({ to: '/backend-users', name: 'Backend Users', Icon: MdAccountCircle });
    checkPermissions(loginData, 'group_list') && navItems.push({ to: '/users-groups', name: 'Users Groups', Icon: MdAccountCircle });
    checkPermissions(loginData, 'group_permissions') && navItems.push({ to: '/manage-group-permissions', name: 'Permissions', Icon: MdVpnKey });
    checkPermissions(loginData, 'searches') && navItems.push({ to: '/searches', name: 'Searches', Icon: MdSearch });
    checkPermissions(loginData, 'failed_urls') && navItems.push({ to: '/failed-urls', name: 'Failed Urls', Icon: MdErrorOutline });
    checkPermissions(loginData, 'failed_urls') && navItems.push({ to: '/frequently-used-urls', name: 'Frequently used Urls', Icon: MdErrorOutline });
    checkPermissions(loginData, 'api_documentation') && navItems.push({
      name: 'APIs', Icon: MdDns,
      subMenus: [
        { to: '/swissearch-api-documentation', name: 'Swissearch Apis', Icon: MdDns },
        { to: '/api-documentation', name: 'Admin Apis', Icon: MdDns },
        { to: '/mobile-api-documentation', name: 'Mobile Apis', Icon: MdDns }
      ]
    });


    if (checkPermissions(loginData, 'view_static_pages')) {
      let subMenus = [
        { to: '/faq', name: 'FAQ', Icon: MdDns },
        { to: '/about', name: 'About Us', Icon: MdDns },
        { to: '/privacy', name: 'Privacy Policy', Icon: MdDns },
        { to: '/term', name: 'Term and Conditions', Icon: MdDns },
        { to: '/child-safety-policy', name: 'Child Safety Policy', Icon: MdDns },
        
      ];
      if (process.env.REACT_APP_VERSION && process.env.REACT_APP_VERSION !== '1.0.0') {
        subMenus.push({ to: '/advertising-guidelines', name: 'Advertising Guidelines', Icon: MdDns });
      }
      navItems.push({
        name: 'CMS Pages', Icon: MdDns,
        subMenus: subMenus
      });
      
    }
    (checkPermissions(loginData, 'change_enrichment_settings') || checkPermissions(loginData, 'get_app_version')) && navItems.push({ to: '/settings', name: 'Settings', Icon: MdSettings });
    return (
      <aside className={bem.b()} data-image={sidebarBgImage}>
        <div className={bem.e('background')} />
        <div className={bem.e('content')}>
          <Navbar>
            <SourceLink className="navbar-brand d-flex">
              <div className="text-white">
                Swis Admin Panel
              </div>
              <div className="version-name">version {process.env.REACT_APP_VERSION}</div>
            </SourceLink>
          </Navbar>
          <Nav vertical>
            {navItems.map(({ to, name, exact, Icon, subMenus = null }, index) => {
              return (

                <div key={`nav${index}`}>
                  {
                    (subMenus && subMenus.length > 0) ?
                      <div><NavItem
                        className={bem.e('nav-item')}
                        onClick={this.handleClick('Pages')}
                      >
                        <BSNavLink className={bem.e('nav-item-collapse')}>
                          <div className="d-flex">
                            <Icon className={bem.e('nav-item-icon')} />
                            <span className="">{name}</span>
                          </div>
                          <MdKeyboardArrowDown
                            className={bem.e('nav-item-icon')}
                            style={{
                              padding: 0,
                              transform: this.state.isOpenPages
                                ? 'rotate(0deg)'
                                : 'rotate(-90deg)',
                              transitionDuration: '0.3s',
                              transitionProperty: 'transform',
                            }}
                          />
                        </BSNavLink>
                      </NavItem>
                        <Collapse isOpen={this.state.isOpenPages}>
                          {subMenus.map(({ to, name, exact, Icon }, index) => (
                            <NavItem key={index} className={bem.e('nav-item')}>
                              <BSNavLink
                                id={`navItem-${name}-${index}`}
                                className="text-uppercase"
                                tag={NavLink}
                                to={to}
                                //activeClassName="active"
                                exact={exact}
                              >
                                <Icon className={bem.e('nav-item-icon')} />
                                <span className="">{name}</span>
                              </BSNavLink>
                            </NavItem>
                          ))}
                        </Collapse></div>

                      : <NavItem key={index} className={bem.e('nav-item')}>
                        <BSNavLink
                          id={`navItem-${name}-${index}`}
                          className="text-uppercase"
                          tag={NavLink}
                          to={to}
                          //activeClassName="active"
                          exact={exact}
                        >
                          <Icon className={bem.e('nav-item-icon')} />
                          <span className="">{name}</span>
                        </BSNavLink>
                      </NavItem>
                  }

                </div>
              )
            }

            )}
          </Nav>
        </div>
      </aside>
    );
  }
}

const mapStateToProps = (state) => ({
  loginData: (state.loginReducer && state.loginReducer.loginData && state.loginReducer.loginData.user) ? state.loginReducer.loginData.user : null,
});

export default connect(mapStateToProps)(Sidebar);
